import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {map, mergeMap} from 'rxjs/operators';
import {DienstService} from '../../../dienst/dienst.service';
import {Diensten} from '../../../dienst/diensten';

@Component({
    templateUrl: './client-diensten-beheer.page.html',
    styleUrls: ['./client-diensten-beheer.page.scss'],
    standalone: false
})
export class ClientDienstenBeheerPage implements OnInit {
  private clientService = inject(ClientService);
  private dienstService = inject(DienstService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client$: Observable<Client>;
  diensten$: Observable<Diensten>;

  ngOnInit(): void {
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
    this.diensten$ = this.dienstService.getDiensten$();
  }

  onCancelClicked(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  onOkClicked(client: Client): void {
    this.clientService.updateClient$(client)
      .subscribe(() => this.router.navigateByUrl(`/clienten/${client.getId()}`));
  }
}
